import React from "react";
import classNames from "classnames";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useReportAmountDisplay } from "../../useReportAmountDisplay";
import { GLViewRow } from "../glViewTypes";
import styles from "../GeneralLedgerTable.module.scss";

export const GLAmountCell = React.memo(function GLAmountCell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction, isAccountIncreasingByDebit } = row.original;

    let amount = 0;
    if (rowKind === "transaction" && transaction) {
        amount =
            transaction.creditAmount !== 0
                ? transaction.creditAmount
                : transaction.debitAmount;
        if (
            (isAccountIncreasingByDebit && transaction.creditAmount !== 0) ||
            (!isAccountIncreasingByDebit && transaction.debitAmount !== 0)
        ) {
            amount = -amount;
        }
    }
    const { text, negativeClassName } = useReportAmountDisplay(amount);

    if (rowKind !== "transaction" || !transaction) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell
            className={classNames(styles.numericCell, negativeClassName)}
        >
            {text}
        </ViewTableCell>
    );
});
